// import "@babel/polyfill";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";

// ============================================================================
// Redirect silenzioso da "/" a basePath tenant (no reload)
// ============================================================================
// Storicamente questo redirect avveniva in App.componentDidMount via
// `window.location.pathname = basePath`, che causa un RELOAD completo dopo
// il primo paint. In dev (utente atterra su localhost:3000/) questo si
// manifesta come "volantino caricato e poi ricaricato". Lo facciamo qui,
// prima di root.render, con history.replaceState → URL aggiornato in modo
// silenzioso, niente reload. Il Router monta direttamente col path corretto.
try {
  // eslint-disable-next-line global-require
  const { serverResponse: sr } = require("./util/fakeServer");
  if (window.location.pathname === "/") {
    let target = process.env.PUBLIC_URL || "/";
    if (window.location.pathname.search("preview") !== -1) {
      target = "preview";
    } else if (
      sr &&
      sr.config &&
      sr.config.client_code !== null &&
      sr.config.client_code !== "" &&
      sr.config.client_code !== undefined
    ) {
      target = sr.config.client_code + "/" + sr.config.slug;
    }
    if (target && target[0] !== "/") target = "/" + target;
    if (target && !target.endsWith("/")) target = target + "/";
    window.history.replaceState({}, "", target);
    // eslint-disable-next-line no-console
    console.log(
      `%c[redirect]%c silent / → ${target} (history.replaceState, no reload)`,
      "color:#7c3aed;font-weight:bold",
      "color:#6b7280"
    );
  }
} catch (_e) {
  /* best-effort */
}

// ============================================================================
// Prefetch volantino — Fase B (post-bundle, rolling window)
// ============================================================================
// Lo script inline in public/index.html (Fase A) ha già fatto preload HIGH
// delle prime 1-2 immagini visibili (index + page_1 desktop / page_1 mobile)
// durante il download del bundle. Qui partiamo con la prima finestra di
// prefetch (4 pagine successive). Le finestre successive sono triggate da
// CustomCarousel.componentDidUpdate ad ogni cambio slide → rolling window.
// ============================================================================
try {
  // eslint-disable-next-line global-require
  const { prefetchAhead } = require("./helper/imagePrefetch");
  // Inizio sempre da slide 0 (sia desktop che mobile partono lì sull'awesome
  // slider — l'eventuale slideIndex=1 iniziale del mobile viene gestito dal
  // primo componentDidUpdate del CustomCarousel).
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => prefetchAhead(0, 4, "boot"), {
      timeout: 500,
    });
  } else {
    setTimeout(() => prefetchAhead(0, 4, "boot"), 0);
  }
} catch (_e) {
  /* prefetch best-effort: non bloccare il boot dell'app */
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
